/**
 * Ícone de telefone (line-icon) — GUPM-158.
 * Espelha o `ic('phone')` do protótipo v5.10: SVG com `stroke="currentColor"`,
 * então herda a cor do contexto (red-300 no botão do header; escuro sobre o
 * botão colorido do modal). Substitui o emoji 📞, que renderiza colorido e
 * destoa do box.
 */
export function PhoneIcon({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      style={{ display: 'inline-block', verticalAlign: '-0.15em', flexShrink: 0 }}
    >
      <path d="M5 4h3l2 5-2 1.5a11 11 0 0 0 5 5L15 13l5 2v3a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2Z" />
    </svg>
  );
}
